<template>
  <v-container fluid grid-list-md style="padding: 20px">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="
            carregaUsuarios(empresaSelecionada);
            carregaLojistas(empresaSelecionada);
          "
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px">
              <v-toolbar-title class="textoUser">USUÁRIOS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Procurar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoUsuario = true" tile color="#3BA8A2">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom v-if="user.tipo === 'ADMIN' || user.tipo === 'ADMIN_PRODUTORA'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B"
                    >mdi-pencil</v-icon
                  >
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo === 'ADMIN' || user.tipo === 'ADMIN_PRODUTORA'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000"
                    >mdi-delete</v-icon
                  >
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <p style="margin: 0px">
              <v-icon :color="item.ativo == true ? 'success' : 'error'"
                >mdi-circle</v-icon
              >
            </p>
          </template>
          <template v-slot:[`item.tipo`]="{ item }">
            <p v-if="item.tipo == 'ADMIN'" style="margin: 0px">Administrador</p>
            <p v-if="item.tipo == 'CAIXA'" style="margin: 0px">Caixa</p>
            <p v-if="item.tipo == 'GERENTE'" style="margin: 0px">Gerente</p>
            <p v-if="item.tipo == 'ATENDENTE'" style="margin: 0px">Atendente</p>
            <p v-if="item.tipo == 'ADMIN_LOJISTA'" style="margin: 0px">
              Lojista Administrador
            </p>
            <p v-if="item.tipo == 'ADMIN_PRODUTORA'" style="margin: 0px">
              Administrador Produtora
            </p>
          </template>
          <template v-slot:no-data>
            <v-row>
              <v-col>
                <v-alert
                  dark
                  dense
                  text
                  outlined
                  color="warning"
                  icon="info"
                  style="margin: 0px"
                  >Nenhum usuário cadastrado</v-alert
                >
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoUsuario" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-subtitle>* indica preenchimento obrigatório</v-card-subtitle>
        <v-card-text style="padding-bottom: 0px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Nome*"
                outlined
                dense
                hide-details
                v-model="editedItem.nome"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="E-mail*"
                outlined
                dense
                hide-details
                v-model="editedItem.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field
                label="Senha*"
                outlined
                dense
                hide-details
                v-model="editedItem.password"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6">
              <v-text-field
                label="PIN"
                outlined
                dense
                hide-details
                v-model="editedItem.pin"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-select
                label="Lojista*"
                outlined
                dense
                hide-details
                v-model="editedItem.lojistaId"
                :items="lojistas"
                item-text="nome"
                item-value="id"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-select
                label="Tipo de Usuário*"
                outlined
                dense
                hide-details
                v-model="editedItem.tipo"
                :items="tiposUsuarioFiltrados"
                item-text="text"
                item-value="value"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoUsuario = false"
            >Fechar</v-btn
          >
          <v-btn
            text
            color="success"
            @click="salvarUsuario"
            v-if="editedIndex == -1"
            >Salvar</v-btn
          >
          <v-btn
            text
            color="success"
            @click="editarUsuario"
            v-if="editedIndex != -1"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref="chamaSnackbar" />
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#3BA8A2"
      :is-full-page="fullPage"
    ></loading>
  </v-container>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { baseApiUrl } from "@/global";
import Snackbar from "../componentes/snackbar.vue";
import axios from "axios";
import { mapState } from "vuex";
export default {
  components: { Snackbar, Loading },
  data: () => ({
    isLoading: false,
    fullPage: true,
    lojistas: [],
    tabela: {
      busca: "",
      cabecalho: [
        { text: "Nome", align: "start", value: "nome" },
        { text: "E-mail", value: "email" },
        { text: "Tipo", value: "tipo" },
        { text: "Lojista", value: "lojista.nome" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "action", sortable: false },
      ],
      carregamento: false,
      conteudo: [],
    },
    tiposUsuario: [
      { text: "Administrador", value: "ADMIN" },
      { text: "Caixa", value: "CAIXA" },
      // { text: 'Gerente', value: 'GERENTE' },
      { text: "Atendente", value: "ATENDENTE" },
      { text: "Lojista Administrador", value: "ADMIN_LOJISTA" },
      { text: "Gerente Administrador", value: "ADMIN_PRODUTORA" },
    ],
    dialogoUsuario: false,
    editedIndex: -1,
    editedItem: {
      nome: "",
      email: "",
      password: "",
      tipo: "",
      imagem: "",
      empresaId: "",
      lojistaId: "",
      ativo: true,
      pin: "",
    },
    defaultItem: {
      nome: "",
      email: "",
      password: "",
      tipo: "",
      imagem: "",
      empresaId: "",
      ativo: true,
      pin: "",
    },
    empresas: [],
    empresaSelecionada: "",
    lojistaSelecionado: "",
  }),

  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,
    user: (state) => state.userObj,
    companyobj: (state) => state.companyObj,
    formTitle() {
      return this.editedIndex === -1
        ? "Adicionar novo usuário"
        : "Editar usuário";
    },
    tiposUsuarioFiltrados() {
      // Filtrar os tipos de usuário de acordo com o tipo do usuário logado
      if (this.user.tipo === "ADMIN") {
        // Administradores podem cadastrar qualquer tipo de usuário
        return this.tiposUsuario;
      } else {
        // Outros tipos de usuário não podem cadastrar administradores
        return this.tiposUsuario.filter((tipo) => tipo.value !== "ADMIN");
      }
    },
  }),

  watch: {
    dialogoUsuario(val) {
      if (val == false) {
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      }
    },
  },

  mounted() {
    if (this.user.tipo == "ADMIN") {
      this.tabela.cabecalho = [
        { text: "Nome", align: "start", value: "nome" },
        { text: "E-mail", value: "email" },
        { text: "Tipo", value: "tipo" },
        { text: "Lojista", value: "lojista.nome" },
        { text: "PIN", value: "pin" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "action", sortable: false },
      ];
      this.carregaEmpresas();
    } else if (this.user.tipo == "ADMIN_PRODUTORA") {
      this.tabela.cabecalho = [
        { text: "Nome", align: "start", value: "nome" },
        { text: "E-mail", value: "email" },
        { text: "Tipo", value: "tipo" },
        { text: "Lojista", value: "lojista.nome" },
        { text: "PIN", value: "pin" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "action", sortable: false },
      ];
      this.carregaUsuarios(this.companyobj.id);
      this.carregaLojistas(this.companyobj.id);
    } else {
      this.tabela.cabecalho = [
        { text: "Nome", align: "start", value: "nome" },
        { text: "E-mail", value: "email" },
        { text: "Tipo", value: "tipo" },
        { text: "Lojista", value: "lojista.nome" },
        { text: "Ativo", value: "ativo" },
      ];
      this.carregaUsuarios(this.companyobj.id);
      this.carregaLojistas(this.companyobj.id);
    }
  },

  methods: {
    async carregaEmpresas() {
      await axios
        .get(
          baseApiUrl +
            'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' +
            sessionStorage.getItem("accToken")
        )
        .then((response) => {
          if (response.data.length > 0) {
            this.empresas = response.data;
          }
        });
    },

    async carregaLojistas(empresaId) {
      let url = "";

      if (empresaId) {
        url =
          baseApiUrl +
          'Lojistas?filter={"where":{"empresaId":"' +
          empresaId +
          '"}, "fields":{"nome": true, "id": true}, "order": "nome ASC"}&access_token=' +
          sessionStorage.getItem("accToken");
      } else {
        url =
          baseApiUrl +
          'Lojistas?filter={"where":{"empresaId":"' +
          this.user.empresaId +
          '"}, "order": "nome ASC"}&access_token=' +
          sessionStorage.getItem("accToken");
      }

      await axios.get(url).then((response) => {
        if (response.data) {
          this.lojistas = response.data;
        }
      });
    },

    async carregaUsuarios(empresaId) {
      let url = "";
      this.tabela.conteudo = [];
      this.isLoading = true;
      this.tabela.carregamento = true;

      if (empresaId) {
        url =
          baseApiUrl +
          'Usuarios?filter={"where":{"and":[{"empresaId":"' +
          empresaId +
          '"}]}, "order":"nome ASC", "include": "lojista"}&access_token=' +
          sessionStorage.getItem("accToken");
      } else {
        url =
          baseApiUrl +
          'Usuarios?filter={"where":{"empresaId":"' +
          this.companyobj.id +
          '"}, "order":"nome ASC", "include": "lojista"}&access_token=' +
          sessionStorage.getItem("accToken");
      }

      await axios.get(url).then((response) => {
        if (response.data) {
          this.tabela.conteudo = response.data;
          this.tabela.carregamento = false;
        }
        this.isLoading = false;
      });
    },

    editItem(item) {
      this.isLoading = true;
      this.editedIndex = this.tabela.conteudo.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogoUsuario = true;
      this.isLoading = false;
    },

    async salvarUsuario() {
      var vm = this;
      if (
        this.editedItem.nome ||
        this.editedItem.email ||
        this.editedItem.password ||
        this.editedItem.tipo ||
        this.editedItem.lojistaId
      ) {
        this.isLoading = true;
        this.editedItem.empresaId =
          this.user.tipo == "ADMIN"
            ? this.empresaSelecionada
            : this.companyobj.id;
        await axios
          .post(
            baseApiUrl +
              "Usuarios/replaceOrCreate?access_token=" +
              sessionStorage.getItem("accToken"),
            this.editedItem
          )
          .then((response) => {
            if (response.data) {
              this.isLoading = false;
              this.dialogoUsuario = false;
              vm.$refs.chamaSnackbar.snack(
                "green",
                "Operação realizada com sucesso!",
                "INFORMAÇÃO"
              );
              this.carregaUsuarios(
                this.user.tipo == "ADMIN"
                  ? this.empresaSelecionada
                  : this.companyobj.id
              );
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack(
              "red",
              "Erro ao realizar operação",
              "DESCULPE"
            );
          });
      } else {
        vm.$refs.chamaSnackbar.snack(
          "orange",
          "Preencha os campos para prosseguir",
          "ATENÇÃO"
        );
      }
    },

    async editarUsuario() {
      var vm = this;
      if (
        this.editedItem.nome ||
        this.editedItem.email ||
        this.editedItem.password ||
        this.editedItem.tipo ||
        this.editedItem.lojistaId
      ) {
        this.isLoading = true;
        this.editedItem.empresaId =
          this.user.tipo == "ADMIN"
            ? this.empresaSelecionada
            : this.companyobj.id;
        await axios
          .put(
            baseApiUrl +
              "Usuarios/" +
              this.editedItem.id +
              "?access_token=" +
              sessionStorage.getItem("accToken"),
            this.editedItem
          )
          .then((response) => {
            if (response.data) {
              this.isLoading = false;
              this.dialogoUsuario = false;
              vm.$refs.chamaSnackbar.snack(
                "green",
                "Operação realizada com sucesso!",
                "INFORMAÇÃO"
              );
              this.carregaUsuarios(
                this.user.tipo == "ADMIN"
                  ? this.empresaSelecionada
                  : this.companyobj.id
              );
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack(
              "red",
              "Erro ao realizar operação",
              "DESCULPE"
            );
          });
      } else {
        vm.$refs.chamaSnackbar.snack(
          "orange",
          "Preencha os campos para prosseguir",
          "ATENÇÃO"
        );
      }
    },

    async deleteItem(item) {
      var r = confirm("Realmente deseja EXCLUIR o usuário " + item.nome + "?");
      if (r == true) {
        await axios
          .delete(
            baseApiUrl +
              "Usuarios/" +
              item.id +
              "?access_token=" +
              sessionStorage.getItem("accToken")
          )
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "success",
              "Operação realizada com sucesso!",
              "INFORMAÇÃO"
            );
            this.carregaUsuarios(
              this.user.tipo == "ADMIN"
                ? this.empresaSelecionada
                : this.companyobj.id
            );
          });
      }
    },
  },
};
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #424f4e;
  font-size: 17px;
}

@font-face {
  font-family: Roboto;
  src: url("https://fonts.google.com/specimen/Roboto");
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}

span.v-stepper__step__step.primary {
  background-color: #009b99 !important;
  border-color: #009b9b !important;
}

.theme--light.v-stepper .v-stepper__label {
  color: #009b99;
}

.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
  color: #009b99;
}
</style>
